import React from "react";
import wordmark from "../../../assets/images/logo-bimify-dark.svg";

/** "Welcome to" above the Bimify wordmark, used as the auth page title */
const WelcomeTitle = () => (
	<>
		<span className="auth-wrapper__welcome">Welcome to</span>
		<img src={wordmark} alt="Bimify" className="auth-wrapper__wordmark" />
	</>
);

export default WelcomeTitle;
